import PrompterEdit from '../PrompterEdit/PrompterEdit';
import PrompterGenerate from '../PrompterGenerate/PrompterGenerate';
import PrompterScene from '../PrompterScene/PrompterScene';
import { Content, Header, Wrapper } from './Prompter.style';

export type PrompterProps = {
  isEmployee: boolean;
  mode: EditMode;
  projectType: 'object' | 'scene';
  focusMode: FocusMode;
  isAiRunning: boolean;
  onPrompt: (prompt: string) => void;
};

export function Prompter(props: PrompterProps) {
  const { mode, focusMode, projectType, isAiRunning, isEmployee } = props;

  const Cmp = getCmp({ projectType, focusMode });

  if (!Cmp) {
    return null;
  }

  return (
    <Wrapper className='Prompter-wrapper' data-testid='Prompter-wrapper'>
      <Header></Header>
      <Content>
        <Cmp
          mode={mode}
          isAiRunning={isAiRunning}
          onPrompt={props.onPrompt}
          isEmployee={isEmployee}
        />
      </Content>
    </Wrapper>
  );
}

export const getCmp = (params: any) => {
  const { projectType, focusMode } = params;

  if (projectType === 'scene') {
    return PrompterScene;
  }

  if (focusMode === 'none') {
    return null;
  }

  return focusMode === 'spawn' ? PrompterGenerate : PrompterEdit;
};

export default Prompter;
